import { Injectable } from '@angular/core';
import { SessionService } from './session.service';

interface IPayload {
  userRoleId: number
  url: string
}

/**
 * Role-based access control for pages and features
 */
@Injectable()
export class PermissionService {
  // Role ids with full application permissions
  private readonly fullPermission: number[] = [1, 2, 3, 4, 5, 6, 7, 8, 14];


  constructor(
    private readonly sessionService: SessionService
  ) {}

  /**
   * True when the given role is allowed to access the URL
   * @param {number} userRoleId Role id of the user
   * @param {string} url Target URL path
   * @returns {boolean} True when access is granted
   */
  isGranted(userRoleId: number, url: string): boolean {

    const payload: IPayload = {
      userRoleId: userRoleId,
      url
    }

    if (this.checkUserRole(payload))
      return true;
    return false;
  }

  /**
   * Role-specific URL allowance rules
   * @param {IPayload} payload { userRoleId, url }
   * @returns {boolean} True when the role has permission
   */
  private checkUserRole(payload: IPayload): boolean {

    let result = false;
    switch (payload.userRoleId) {
      case 7:
          result = true;
        break;

      case 9:
          result = payload.url === '/complete-registration' ? true : false;
        break;

      // case 11:
      //     result = payload.url === '/documents-verification' ? true : false;
      //   break;

      case 12:
          result = true;
        break;

      default:
        break;
    }

    return result;
  }

  /**
   * True when the current user role is allowed and holds a valid token
   * @returns {boolean} True when the user is allowed
   */
  isAllowed(): boolean {
    // PMM-247
    return (
      this.sessionService.getRoleId() === 1 ||
      this.sessionService.getRoleId() === 2 ||
      this.sessionService.getRoleId() === 3 ||
      this.sessionService.getRoleId() === 4 ||
      this.sessionService.getRoleId() === 5 ||
      this.sessionService.getRoleId() === 6 ||
      this.sessionService.getRoleId() === 7 ||
      this.sessionService.getRoleId() === 8 ||
      this.sessionService.getRoleId() === 13 ||
      this.sessionService.getRoleId() === 14
    ) && this.sessionService.hasToken()
  }
}
